module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/footer_background-f4c4db335793d5c09126864299244a83.png";